import { initialAction } from './initialActions';
import * as containers from './containers';
import * as constants from './constants';
const reducer = (state = {}) => {
    return state;
};
const didomiModule = { containers, reducer, initalAction: initialAction, constants };
export default didomiModule;
